// extracted by mini-css-extract-plugin
var _1 = "ProfileBuildingsWidgetItem-moduleProfileBuildingsWidgetItem__QkfHA ListItem-moduleListItem__NInUA";
var _2 = "ProfileBuildingsWidgetItem-modulehover__Saqav";
var _3 = "ProfileBuildingsWidgetItem-moduletext__nh6mD";
export { _1 as "ProfileBuildingsWidgetItem", _2 as "hover", _3 as "text" }
